import {NgModule} from '@angular/core';
import {BackButtonDirective, ScrollbarThemeDirective} from '.';

@NgModule({
  declarations: [ScrollbarThemeDirective, BackButtonDirective],
  exports: [ScrollbarThemeDirective, BackButtonDirective]
})
export class DirectiveModule {}
